module.exports = __webpack_public_path__ + "img/nav-loans.6161b7a3.svg";